import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SharedService } from '../../../../Services/shared.service';
import { DeviceDetectorService } from 'ngx-device-detector';



import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-required-configuration',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './required-configuration.component.html',
  styleUrl: './required-configuration.component.css'
})
export class RequiredConfigurationComponent {
  PREP_UserInfo: any;
  Object: any;
  constructor(
    private _svc: SharedService,
    private _device: DeviceDetectorService,

    private _router: Router
  ) { }
  ngOnInit(): void {
    
    //this._sharedService.SetMock(true);


    this._svc.get_Login_Status().subscribe(x => {
      this.PREP_UserInfo = x;
    })


    this.Object = {
      Camera: false,
      Microphone: false,
      Chrome: false,
      BrowserName: this._device.browser,
      enableBrowser: false,
      NetSpeed: 0,
      IsVersionIssue: true,
      IsMobile: false
    }
    if (this._device.os.toLowerCase() == 'windows')
      this.checkCameraMicrophone(this.Object);
    else {
      this.Object.Camera = true;
      this.Object.Microphone = true;
    }

    this.checkBrowser();

    this.CheckNetSpeed();

    this._svc.Set_ExamStatus(false);
  }
  checkCameraMicrophone(obj: any) {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ audio: true, video: true })
        .then(function (stream) {
          obj.Camera = true;
          obj.Microphone = true;
        })
        .catch(function (err) {
          obj.Camera = false;
          obj.Microphone = false;
        });
    } else {
      obj.Camera = false;
      obj.Microphone = false;
    }
  }
  CheckNetSpeed() {
    
    this._svc.testDownloadSpeed().then(speed => {
      
      this.Object.NetSpeed = speed;
    }).catch(console.error);
  }

  checkBrowser() {


    var usingBrowser = this._svc.BrowserList.find((x: any) => x.Browser.toLowerCase() == this._device.browser.toLowerCase())
    if (usingBrowser)
      this.Object.enableBrowser = true;
    else
      this.Object.enableBrowser = false;
    const broser = this._device.browser

    if (this.Object.enableBrowser) {
      //this.Object.Chrome = true;
      this.Object.IsVersionIssue = false;
      this.Object.IsMobile = false;
      if (this._device.os != "windows")
        this.Object.IsMobile = true;
      this.Object.Version = this._device.browser_version;
      var array = this.Object.Version.split('.');
      var _v = parseInt(array[0]);
      if (_v >= usingBrowser.Min_Version)
        this.Object.enableBrowser = true;
      else {
        this.Object.enableBrowser = false;
        this.Object.IsVersionIssue = true;
      }

    }
    else {
      this.Object.enableBrowser = false;
    }
  }

  Proceed() {
    this._router.navigate(['/exam']);

  }

}
